import {CONSONANT_VOWEL_PAIRS_TT} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_tt.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_TT_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_TT} title="Consonant-Vowel Pairs: ㄸ (tt)" />
     </>
);}